import { SectionTitle, TopWave } from '../../../components'

export const BranchesOfGovernment = () => {
	return (
		<div className='homeCard'>
			<TopWave />
			<SectionTitle title='Ramas del poder público' />

			<div
				className='subjectCard mb-5 ownShadow'
				data-aos='fade-up'
				data-aos-duration='700'
				data-aos-once='true'
			>
				<p>
					Las Ramas del Poder Público en Colombia desempeñan un papel
					fundamental en la estructura gubernamental del país. Se dividen en
					Ejecutiva, Legislativa y Judicial, y funcionan de manera
					independiente, pero se complementan entre sí para garantizar un
					equilibrio y la separación de poderes. En este escrito, exploraremos
					cada una de estas ramas, sus funciones y quiénes las conforman.
				</p>

				<hr />
				<div>
					<h4>Rama Ejecutiva</h4>
					<p>
						La rama Ejecutiva es la que representa el gobierno. Está conformada
						a nivel nacional por el Presidente de la República, el
						Vicepresidente, los Ministros y los directores de departamentos
						administrativos. A nivel departamental está conformada por los
						Gobernadores y los secretarios de gabinete; y a nivel municipal o
						distrital por los Alcaldes y sus secretarios de gabinete. Algunas de
						sus funciones son:
					</p>
					<ul>
						<li>Promover el desarrollo económico y social del país.</li>
						<li>Garantizar la seguridad y el orden público.</li>
						<li>
							Dirigir la política exterior y representar al país en el ámbito
							internacional.
						</li>
						<li>
							Administrar los recursos y presupuestos del Estado. Y deciden en
							que utilizarlo.
						</li>
						<li>Ejecutar las decisiones judiciales.</li>
					</ul>
					<br />
					<h5>El presidente de La República</h5>
					<p>
						El Presidente actúa como Jefe de Estado, Jefe de Gobierno y suprema
						autoridad administrativa. durante un periodo de cuatro años, sin
						posibilidad de ser reelegido. Para llegar a ese cargo debe ser
						colombiano de nacimiento, ser ciudadano en ejercicio y tener más de
						treinta años al momento de la elección.
					</p>
					<br />
					<h6>Funciones como jefe de Estado</h6>
					<ul>
						<li>
							Dirige la política internacional y el manejo de las relaciones
							internacionales.
						</li>
						<li>
							Representa al Estado colombiano en el concierto internacional.
						</li>
						<li>Vela por la seguridad exterior de la República.</li>
						<li>
							Defiende la independencia y la honra de la Nación y la
							inviolabilidad del territorio.
						</li>
						<li>
							Declara la guerra con permiso del Senado, o cuando se trata de
							repeler una agresión extranjera, puede declararla sin autorización
							previa de dicha cámara.
						</li>
						<li>
							Asume en forma exclusiva la responsabilidad y las facultades de
							dirección de los procesos de paz.
						</li>
					</ul>
					<br />
					<h6>Funciones como jefe de Gobierno</h6>
					<ul>
						<li>
							Es el encargado de la conducción política del país tanto en el
							orden nacional como en el internacional.
						</li>
						<li>Nombra y separa de su cargo a sus inmediatos colaboradores.</li>
						<li>
							Dirige y coordina sus actividades para el eficaz logro de los
							fines estatales.
						</li>
						<li>
							Dirigir la fuerza pública y disponer de ella como comandante
							supremo de las fuerzas armadas de la republica.
						</li>
						<li>Promulgar obedecer y sancionar las leyes.</li>
					</ul>
					<br />
					<h6>Funciones como Suprema Autoridad Administrativa</h6>
					<ul>
						<li>
							El Presidente de la República distribuye los asuntos, según su
							naturaleza, entre los ministerios, departamentos administrativos y
							establecimientos públicos.
						</li>
						<li>
							Ejerce la inspección y vigilancia sobre determinadas actividades y
							servicios de interés general.
						</li>
						<li>
							Vela por la recaudación y administración de las rentas y caudales
							públicos.
						</li>
					</ul>
				</div>
				<hr />
				<div>
					<h4>Rama Legislativa</h4>
					<p>
						Se encarga de la elaboración y aprobación de leyes, así como del
						control político al Gobierno. Es el órgano responsable de
						representar a los ciudadanos y proteger sus intereses.
					</p>
					<p>
						Está conformada por el Congreso de la República, que se divide en
						dos: la cámara del Senado y la Cámara de Representantes. Estas
						instituciones son elegidas por los ciudadanos a través del voto
						popular cada 4 años. Asimismo, La cámara del Senado cuenta con 102
						integrantes, y la cámara del representantes 166 integrantes. Para un
						total de 268 congresistas.
					</p>
					<br />
					<h5>Funciones del Congreso</h5>
					<ul>
						<li>
							Elaborar, discutir y aprobar leyes que regulan la convivencia y el
							funcionamiento del Estado.
						</li>
						<li>
							Representar a los ciudadanos y sus intereses en el ámbito
							legislativo.
						</li>
						<li>
							Ejercer el control político sobre el Gobierno y las entidades
							estatales.
						</li>
						<li>Reformar la Constitución cuando sea necesario</li>
						<li>
							Es el encargado de admitir la renuncia del Presidente y del
							Vicepresidente.
						</li>
						<li>Ascensos militares conferidos por el Gobierno</li>
						<li>
							Concede licencia temporal al Presidente para separase del cargo.
						</li>
						<li>
							Permite a prohíbe el tránsito de tropas extranjeras por el
							territorio nacional.
						</li>
						<li>
							Autoriza al Gobierno Nacional para declarar la guerra a otras
							naciones.
						</li>
						<li>Elige los Magistrados de la Corte Constitucional.</li>
						<li>Elige al Procurador General de la Nación.</li>
					</ul>
				</div>
				<hr />
				<div>
					<h4>Rama Judicial</h4>
					<p>
						Responsable de administrar justicia y garantizar el cumplimiento de
						las leyes. Su principal función es resolver conflictos legales de
						manera imparcial y proteger los derechos de los ciudadanos.
						<br />
						<br />
						La rama judicial está conformada por las llamadas altas cortes
						(Corte Suprema de Justicia, la Corte Constitucional) y por la
						Fiscalía General de la Nación.
						<br />
						<br />
						La Corte Constitucional resguarda la Constitución de la República.{' '}
						<br />
						Está conformada por nueve magistrados que ejercen durante un periodo
						de ocho años. A éstos los elige el Senado a partir de sendas ternas
						enviadas por el Consejo de Estado, la Corte Suprema de Justicia y el
						Presidente (sendas ternas: cada uno propone un candidato)
					</p>
					<h5>Funciones</h5>
					<ul>
						<li>Administrar justicia de manera independiente e imparcial.</li>
						<li>Resolver conflictos legales y aplicar las leyes vigentes.</li>
						<li>Proteger los derechos fundamentales de los ciudadanos.</li>
						<li>Velar por el cumplimiento de las decisiones judiciales.</li>
					</ul>
				</div>
				<hr />
				<h5>Bibliografía</h5>
				<ul>
					<li>
						Webmaster. (s. f.). Organigrama del estado Colombiano-Rama
						Ejecutiva. Edu.co. Recuperado 12 de julio de 2024, de
						https://cienciassociales.uniandes<br />.edu.co/desarrollos/organigrama-estado-colombiano/index.php?ac=re
					</li>
					<li>
						Manual de Estructura del Estado - Función Pública. (s. f.). Gov.Co.
						Recuperado 12 de julio de 2024, de
						https://www.funcionpublica.gov.co<br />/eva/gestornormativo/manual-estado/index.php
					</li>
					<li>
						(S. f.). Gov.co. Recuperado 12 de julio de 2024, de
						https://www.funcionpublica.gov.co<br />/documents/418537/7869206/<br />Rama+Ejecutiva+_Nivel+Central+(1).pdf/c65aa628-ed81-09af-30ed-f281faf3c4fa?version=1.0
					</li>
				</ul>
			</div>
		</div>
	)
}
